import {Dialog, IconButton} from 'platform/components';
import {Box, Clickable, Grid, HStack, Icon, Text, VStack} from 'platform/foundation';
import styled from 'styled-components';

import {suffixTestId, TestIdProps} from 'shared/web';

import {languageDialogItems} from '../../../../../constants/languageDialogItems';
import i18n from '../../../../../i18n/i18n';
import {AppLanguage} from '../../../../../types/AppLanguage';

interface LanguageDialogModalProps extends TestIdProps {
  isOpen: boolean;
  onChoseLanguage: (lang: AppLanguage) => void;
  onClose: () => void;
}

export function LanguageDialogModal({
  isOpen,
  onChoseLanguage,
  onClose,
  ...props
}: LanguageDialogModalProps) {
  const handleChoseLanguage = (lang: AppLanguage) => {
    onChoseLanguage(lang);
    onClose();
  };

  return (
    <Dialog isOpen={isOpen} disableBodyPadding data-testid={suffixTestId('wrapper', props)}>
      <Box padding={8}>
        <VStack spacing={8}>
          <HStack align="center" justify="space-between">
            <Text alternative size="large" data-testid={suffixTestId('title', props)}>
              {i18n.t('general.actions.chooseLanguage')}
            </Text>
            <IconButton
              icon="navigation/close"
              onClick={onClose}
              data-testid={suffixTestId('closeButton', props)}
            />
          </HStack>
          <Grid columns={2}>
            {Object.entries(languageDialogItems).map(([lang, item]) => (
              <Clickable
                key={item.title}
                onClick={() => handleChoseLanguage(lang as AppLanguage)}
                data-testid={suffixTestId(`languageButton-${lang}`, props)}
              >
                <StyledLanguageButton $chosen={i18n.resolvedLanguage === lang}>
                  <HStack align="center" spacing={2}>
                    <Icon
                      value={item.icon}
                      size={5}
                      data-testid={suffixTestId(`flag-${lang}`, props)}
                    />
                    <Text alternative data-testid={suffixTestId(`languageName-${lang}`, props)}>
                      {item.title}
                    </Text>
                  </HStack>
                </StyledLanguageButton>
              </Clickable>
            ))}
          </Grid>
        </VStack>
      </Box>
    </Dialog>
  );
}

const StyledLanguageButton = styled.div<{$chosen: boolean}>`
  border: 1px solid transparent;

  &:hover {
    border-color: ${({theme}) => theme.colors.palettes.blue[10][100]};
  }

  background-color: ${({theme, $chosen}) =>
    $chosen ? theme.colors.palettes.blue[10][100] : 'initial'};
  border-radius: ${({theme}) => theme.getSize(2)};
  padding: ${({theme}) => theme.getSize(4)};
`;
